import Vue from 'vue';
import Vuex from 'vuex';
import SearchApi from './../apis/searchApi';
import UrlHelper from './../helpers/urlHelper';

Vue.use(Vuex);

export default class Store {
	state() {
		return {
			query: {
				query: '',
				startDate: null,
				endDate: null,
				filters: [],
				facets: [],
				orderBy: null,
				archive: false,
				page: 1,
				pageSize: 10
			},
			search: {
				years: [],
				availableFilters: [],
				result: {
					total: 0,
					results: []
				}
			},
			archive: {
				years: [],
				availableFilters: [],
				result: {
					total: 0,
					results: []
				}
			},
			section: 'search'
		};
	}

	getters() {
		return {
			filterIndex: (state) => (payload) => {
				return state.query.filters.findIndex(filter =>
					filter.field == payload.field &&
					filter.value == payload.value &&
					filter.operator == payload.operator);
			},
			isFilterActive: (state, getters) => (payload) => {
				return getters.filterIndex(payload) != -1;
			},
			getQueryText: (state, getters) => {
				return state.query.query;
			},
			getStartDate: (state) => {
				return state.query.startDate;
			},
			getEndDate: (state) => {
				return state.query.endDate;
			},
			getAvailableFilters: (state, getters) => {
				return state[getters.getSection].availableFilters;
			},
			getQueryFilters: (state) => {
				return state.query.filters;
			},
			getResults: (state) => {
 				return state[state.section].result.results;
			},
			getTotal: (state) => (payload) => {
				return state[payload].result.total;
			},
			getCurrentPage: (state) => {
				return state.query.page;
			},
			getTotalPages: (state) => {
				let total = state[state.section].result.total;

				return Math.ceil(total / state.query.pageSize);
			},
			getPages: (state, getters) => {
				let pages = [];
				let currentPage = state.query.page;
				let totalPages = getters.getTotalPages;
				let pagesToDisplay = Math.min(5, totalPages);
				let pagesPerSide = Math.floor(pagesToDisplay / 2);
				let startPage = 1;

				if (currentPage + pagesPerSide > totalPages) {
					startPage = totalPages - pagesToDisplay + 1;
				} else if (currentPage > pagesPerSide) {
				  startPage = currentPage - pagesPerSide;
				}

				for (let index = startPage; index <= startPage + pagesToDisplay - 1; index++) {
					pages.push(index);
				}

				return pages;
			},
			getSection: (state) => {
				return state.section;
			},
			isArchive: (state) => {
				return state.section == 'archive';
			},
			getYears: (state, getters) => {
				return state[getters.getSection].years;
			}
		};
	}

	mutations() {
		return {
			addFilter: (state, payload) => {
				state.query.filters.push(payload);
			},
			removeFilter: (state, payload) => {
				state.query.filters.splice(payload, 1);
			},
			setStartDate: (state, payload) => {
				state.query.startDate = payload;
			},
			setEndDate: (state, payload) => {
				state.query.endDate = payload;
			},
			setQueryText: (state, payload) => {
				state.query.query = payload;
			},
			clearFilters: (state) => {
				state.query.filters = [];

				state.query.startDate = null;
				state.query.endDate = null;
			},
			setAvailableFilters: (state, payload) => {
				state.search.availableFilters = [
					...payload.search
				];
				state.archive.availableFilters = [
					...payload.archive
				];
			},
			setTotal: (state, payload) => {
				state[payload.section].result.total = payload.total;
			},
			setResults: (state, payload) => {
				state[payload.section].result.results = payload.results;
			},
			setCurrentPage: (state, payload) => {
				state.query.page = payload;
			},
			setOrderBy: (state, payload) => {
				state.query.orderBy = payload;
			},
			setSection: (state, payload) => {
				state.section = payload;

				let archiveBlurb = document.getElementById('archive-information');
				if(archiveBlurb)
				{
					archiveBlurb.style.display = state.section === 'archive' ? 'block' : 'none';
				}
			},
			setYears: (state, payload) => {
				if(payload.search)
					state.search.years = payload.search;

				if(payload.archive)
					state.archive.years = payload.archive;
			},
			setQuery: (state, payload) => {
				state.query = payload;
			}
		};
	}

	actions() {
		return {
			changeSection: ({ commit, dispatch }, payload) => {
				commit('setSection', payload);

				return dispatch('changePage', 1);
			},
			changePage: ({ commit, dispatch }, payload) => {
				commit('setCurrentPage', payload);

				return dispatch('search');
			},
			changeOrdering: ({ commit, dispatch }, payload) => {
				commit('setOrderBy', payload);

				return dispatch('search');
			},
			setDate: ({ commit, dispatch }, payload) => {
				if(payload.start)
					commit('setStartDate', payload.date);
				else
					commit('setEndDate', payload.date);

				return dispatch('search');
			},
			setQueryText: ({ commit, dispatch }, payload) => {
				commit('setQueryText', payload);

				return dispatch('search');
			},
			toggleFilter: ({ state, getters, dispatch, commit}, payload) => {
				let index = getters.filterIndex(payload);
				if(index == -1)
					commit('addFilter', payload);
				else
					commit('removeFilter', index);

				commit('setCurrentPage', 1)

				return dispatch('search');
			},
			showFilters: () => {
				if (document.body.classList.contains("is-filtersOpen")) {
					document.body.classList.remove('is-filtersOpen', 'fixed');
				}
				else {
					document.body.classList.add('is-filtersOpen', 'fixed');
				}
			},
			clearFilters: ({ dispatch, commit }) => {
				commit('clearFilters');

				return dispatch('search');
			},
			search: async ({state, commit}) => {
				UrlHelper.encodeQuery({...state.query, section: state.section });

				let searchResult = await SearchApi.search(state.query);
				if(searchResult)
				{
					commit('setTotal', { section: 'search', total: searchResult.total });
					commit('setResults', { section: 'search', results: searchResult.results });
				}

				let archiveResult = await SearchApi.archive(state.query);
				if(archiveResult)
				{
					commit('setTotal', { section: 'archive', total: archiveResult.total });
					commit('setResults', { section: 'archive', results: archiveResult.results });
				}
			},
			loadQuery: async ({commit}) => {
				let query = UrlHelper.decodeQuery();
				if(query)
				{
					//commit('setQueryText', query.query);

					commit('setStartDate', query.startDate);
					commit('setEndDate', query.endDate);

					if(query.filters)
						query.filters.forEach(f => commit('addFilter', f));

					commit('setOrderBy', query.orderBy);
					commit('setCurrentPage', query.page);

					commit('setSection', query.section);
				}
			},
			loadFilters: async ({state, commit}) => {
				let filters = await SearchApi.getFilters();
				if(filters)
					commit('setAvailableFilters', filters);
			},
			loadYears: async ({commit}) => {
				let years = await SearchApi.getYears();
				if(years)
					commit('setYears', years);
			}
		};
	}

	constructor() {
		let opts = {
			state: this.state(),
			getters: this.getters(),
			mutations: this.mutations(),
			actions: this.actions()
		}
		return new Vuex.Store(opts);
	}
}
